import React from "react";
import { useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";
// public and private routing files
import LoggedInRoutes from "./LoggedInRoutes";
import LoggedOutRoutes from "./LoggedOutRoutes";
import ToastAlertProvider from "../providers/ToastAlert";

function AppRouter() {
  const authToken = useSelector((state) => state.auth.isUserLoggedIn);

  const checkAuthentication = (auth) => {
    if (auth) {
      return <LoggedInRoutes />;
    }
    return <LoggedOutRoutes />;
  };

  return (
    <BrowserRouter>
      <ToastAlertProvider>
        <ScrollToTop />
        {checkAuthentication(authToken)}
      </ToastAlertProvider>
    </BrowserRouter>
  );
}

export default AppRouter;
